import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DigitalTools } from '~/static-pages/DigitalTools.page'

const DigitalToolsPage: NextPage = () => {
  const { t } = useTranslation('digitalTools')

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={usePageTitle(t('title'))} />
      <DefaultLayout zeroPadding>
        <DigitalTools />
      </DefaultLayout>
    </div>
  )
}

const getProps: GetProps = () => () => ({
  props: {
    namespaces: ['digitalTools', ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES],
  },
})

export const getStaticProps = getStaticPropsWrapper(getProps)

export default DigitalToolsPage
